export interface ParsedLocalizedImageKey {
  token: string;
  locale?: string;
}

/**
 * Builds an image decorator key as `token` or `token:locale`.
 * Locale casing is preserved so it can match `supportedLanguages` exactly.
 */
export function buildLocalizedImageKey(token: string, locale?: string): string {
  if (!token) {
    return '';
  }

  return locale ? `${token}:${locale}` : token;
}

/**
 * Splits an image decorator key on the first `:`.
 * Tokens themselves do not contain `:`; the remainder is the locale (e.g. `fr-CA`).
 */
export function parseLocalizedImageKey(key: string): ParsedLocalizedImageKey {
  if (!key) {
    return { token: '' };
  }

  const separatorIndex = key.indexOf(':');
  if (separatorIndex === -1) {
    return { token: key };
  }

  const token = key.slice(0, separatorIndex);
  const locale = key.slice(separatorIndex + 1);

  return locale ? { token, locale } : { token };
}

export function isLocalizedImageKey(key: string): boolean {
  return !!parseLocalizedImageKey(key).locale;
}
